import classNames from "classnames";
import { displayUserText, shouldBeInvoiced } from "Client/Detail/SubscriptionUtils";
import React from "react";
import { formatLongDate } from "utilities";
import PlanLabel from "./PlanLabel";

interface Props {
  layout?: "small" | "large"
  start: Date
  type: server.dto.SubscriptionType
  cycle: server.dto.BillingCycle
  users: number
  discount: server.dto.Percentage
  onClick: () => void
}

const SubscriptionDiv = (props: Props) => {
  const divClasses = classNames("white-text hoverable grow1", {
    "padding-large": props.layout !== "small",
    "padding": props.layout === "small",
    "s1_small": props.layout === "small",
  });

  const usersText = props.users === 1 ? "1 internal user" : `${props.users} internal users`;

  const discountText = (props.discount === null || props.discount.value === 0) ? null : `${props.discount.text} discount`;
  return (
    <div
      className={divClasses}
      style={{ flexBasis: 0, backgroundColor: props.type.hexColor }}
      onClick={props.onClick}
    >
      <PlanLabel type={props.type} cycle={props.cycle} />
      <div className="margin-bottom-mini">{formatLongDate(props.start)}</div>
      {displayUserText(props.type.value) && <div className="s1_gray">{usersText}</div>}
      {shouldBeInvoiced(props.type.value) && <div className="s1_gray">{discountText}</div>}
    </div>
  );
};

export default SubscriptionDiv;